import { render, staticRenderFns } from "./FIFResults.vue?vue&type=template&id=33178d24&"
import script from "./FIFResults.vue?vue&type=script&lang=js&"
export * from "./FIFResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports